<div class="section-loading">
    <ad-splash-screen [visible]="true"></ad-splash-screen>
</div>